'use client';

export { default } from './Paper';
export { default as paperClasses } from './paperClasses';
export * from './paperClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Paper/index.js
// module id = 67
// module chunks = 25